import _ from "lodash"
//************************************//
const global = []
//************************************//
export function _setGlobal(key, val) {
  global[key] = val
}
//************************************//
export function _getGlobal(key) {
  return global[key]
}
//************************************//
export const env = (key, defaultValue = '') => {
  // console.log(_getGlobal('env_override'), process.env)
  if (!_getGlobal('env_override') && _.get(window, `env_override`)) {
    const env_override = {}
    _.forEach(_.get(window, `env_override`), (envItemValue, envItemKey) => {
      if (_.startsWith(envItemKey, 'REACT_APP_')) {
        env_override[envItemKey] = envItemValue
      }
    })
    _setGlobal('env_override', {...env_override, ...window.env})
    window.env_override = {}
    window.env = {}
  }
  return _.defaultTo(_.get(_getGlobal('env_override'), `${key}`), _.defaultTo(process.env[key], defaultValue))
}
